function entries_Reducer(state = [], action) {
    switch (action.type) {
        case 'ENTRIES/SET':
            return action.entries;
        case 'ENTRIES/CLEAR':
            return null;
        default:
            return state;
    }
}

export default entries_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/entries.js